export const emojiByGroupId = (groupId: number): string => {
    if(groupId === 1) return '👔';
    if(groupId === 2) return '😎';
    if(groupId === 3) return '✨';
    if(groupId === 4) return '🎉';
    if(groupId === 8) return '🛍';
    if(groupId === 9) return '📱';
    if(groupId === 10) return '🤝';
    if(groupId === 5) return '🌸';
    if(groupId === 6) return '🪄';
    if(groupId === 7) return'⏱️';
    return '';
}